/**
 * OTP Constants
 */
export const OTP_LENGTH = 4;

export const RESEND_TIMER_SECONDS = 30;

export const OTP_TYPE = {
  FORGOT_PASSWORD: 3,
} as const;

